import React, { FormEvent, useEffect, useState } from "react";
import {
  AsideContainer,
  Box,
  Button,
  Container,
  FormBox,
  Input,
  LoadingFlex,
  MarketingSide,
  Wrapper,
  Heading,
  HStack,
  LoginContent,
  InputBase,
  Label,
  ButtonStyled,
  Title,
  TextInfo
} from "./styles";
import logoUx from "../../../../assets/logo-uxdoc.svg";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from "../../../../hooks/auth";
import PuffLoader from "react-spinners/PuffLoader";
import DecorationBackground from "../../components/DecorationBackground";
import IconSvg from "../../../editor/components/IconSvg";
import computerImage from "../../assets/computer-image.svg";
import logoUX from "../../assets/logo-uxdoc.svg";
// import mockupUx from "../../assets/mockup-icon.svg";
import logoUX3 from "../../assets/uxlogotipo.svg";
import mockupUx from "../../assets/mock.svg";
import api from "../../../../services/api";
import { toast, ToastContainer } from "react-toastify";

interface Inputs {
  newPassword: string;
  confirmPassword: string;
}

interface ObjectNewPasswordProps {
  token: string;
  password: string;
  password_confirmation: string;
}

const NewPassword: React.FC = () => {
  const { token } = useParams();
  const { signIn } = useAuth();
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm<Inputs>();

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      scale: 1.05,
      transition: {
        delayChildren: 0.5,
        type: "spring",
        duration: 1,
        stiffness: 200,
        staggerDirection: -1
      }
    }
  };

  const item = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 1.9,
        type: "spring",
        stiffness: 100
      }
    }
  };

  const onSubmit: SubmitHandler<Inputs> = async data => {
    const ObjectForApi: ObjectNewPasswordProps = {
      token: token,
      password: data.newPassword,
      password_confirmation: data.confirmPassword
    };

    try {
      if (data.newPassword !== data.confirmPassword) {
        console.log("Tente novamente. As senhas não são iguais.");
        return toast.error("Tente novamente. As senhas não são iguais.");
      }
      setLoading(true);
      const responseNewPassword = await api.post(
        "password/reset",
        ObjectForApi
      );

      console.log(responseNewPassword.status, "DEU CERTO?");
      toast.success("Senha atualizada com sucesso!");
      setLoading(false);
      setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (error: any) {
      console.log(error, "error when post new password");
      if (
        error.response.data.message === "Incorrect email/password combination."
      ) {
        alert("E-mail ou senha incorreto.");
        setLoading(false);
      }
    }
  };

  //for comit just

  useEffect(() => {
    console.log(token, "o que vem?");
  }, []);

  return (
    <Container>
      <ToastContainer />
      <AsideContainer>
        <LoginContent
          initial="hidden"
          animate="show"
          variants={container}
          as={motion.form}
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* <img src={logoUX} className="logo-login" /> */}

          <div className="hero-login-div">
            <img className="hero-login-img" src={logoUX3} />
          </div>

          <Title>Criar nova senha</Title>
          <TextInfo>
            Crie uma nova senha para voltar a ter acesso à sua conta
          </TextInfo>
          <InputBase
            type="password"
            placeholder="Nova senha"
            minLength={6}
            required
            {...register("newPassword")}
          />
          <InputBase
            type="password"
            placeholder="Confirmar nova senha"
            minLength={6}
            required
            {...register("confirmPassword")}
          />

          <ButtonStyled type="submit">
            {loading ? (
              <LoadingFlex>
                <PuffLoader color="#ffff" size="28" />
              </LoadingFlex>
            ) : (
              `Salvar`
            )}
          </ButtonStyled>
        </LoginContent>
      </AsideContainer>
      <DecorationBackground />
      <MarketingSide>
        <HStack>
          <Heading>Crie documentos com design em poucos cliques</Heading>
        </HStack>
        <IconSvg className="mockup-image" src={mockupUx} description="" />
      </MarketingSide>
    </Container>
  );
};

export default NewPassword;
